import React from 'react';
import {useHistory} from 'react-router-dom';
import {Dropdown} from 'react-bootstrap';
import ChevronRight from '@mui/icons-material/ChevronRightRounded';
import './breadcrumb.css';

const Breadcrumb = ({paths}) => {
  const history = useHistory();

  const handleNavigate = (path) => {
    if (path) {
      history.push(path);
    }
  };

  return (
    <div className="header__breadcrumb">
      {/* Root Element (optional, implied by first path often, but snippet had it separate. 
          We'll rely on paths map like before but style them new) */}

      {paths.map((path, index) => {
        const isActive = index === paths.length - 1;
        const hasBranches = !!path.branches;
        const showDropdown = isActive && hasBranches;

        return (
          <React.Fragment key={index}>
            {/* Separator (Chevron) logic */}
            {index > 0 && (
              hasBranches && showDropdown ? (
                <Dropdown className="d-flex align-items-center">
                  <Dropdown.Toggle
                    as="button"
                    className="breadcrumb-chevron-btn header__breadcrumb-separator"
                    id={`dropdown-sep-${index}`}
                  >
                    <ChevronRight size={16}/>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {path.branches.map((branch, idx) => (
                      <Dropdown.Item
                        key={idx}
                        onClick={() => handleNavigate(branch.link)}
                        active={branch.name === path.name}
                      >
                        {branch.name}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                <span className="header__breadcrumb-separator">
                  <ChevronRight size={16}/>
                </span>
              )
            )}

            {/* Breadcrumb Item */}
            {path.link && !isActive ? (
              <span
                className="header__breadcrumb-item"
                onClick={() => handleNavigate(path.link)}
                role="button"
                tabIndex={0}
              >
                {path.name}
              </span>
            ) : (
              <span className={`header__breadcrumb-item ${isActive ? 'header__breadcrumb-item--active' : ''}`}>
                {path.name}
              </span>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Breadcrumb;